import React from 'react';
import { Link } from 'react-router-dom';

const AboutUs = () => {
    return (
        <div className="max-w-4xl mx-auto py-8">
            <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-100 dark:border-gray-800 p-6 sm:p-8 lg:p-12">
                <h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100 mb-6">About Us</h1>

                <div className="prose prose-gray max-w-none">
                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">Who We Are</h2>
                            <p className="text-gray-700 dark:text-gray-300 mb-4">
                            RewriteKing is a professional text rewriting service dedicated to helping individuals and businesses 
                            communicate more effectively. We understand that in today's fast-paced digital world, clear and 
                            professional communication is essential.
                        </p>
                    </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">Our Mission</h2>
                            <p className="text-gray-700 dark:text-gray-300 mb-4">
                            Our mission is to empower users to express themselves professionally and clearly, regardless of their 
                            writing expertise. We believe that everyone deserves access to high-quality, professional 
                            communication tools.
                        </p>
                    </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">What We Do</h2>
                            <p className="text-gray-700 dark:text-gray-300 mb-4">
                            RewriteKing transforms casual messages into professional communications using advanced AI technology. 
                            Our service offers multiple tone options to suit different contexts and audiences:
                        </p>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                            <div className="flex items-start gap-3 p-4 bg-primary-50 dark:bg-primary-900/30 rounded-lg">
                                <i className="fas fa-briefcase text-primary-600 dark:text-primary-400 mt-1"></i>
                                <div>
                                    <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-1">Professional</h3>
                                    <p className="text-sm text-gray-600 dark:text-gray-400">Business-appropriate tone</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-3 p-4 bg-primary-50 dark:bg-primary-900/30 rounded-lg">
                                <i className="fas fa-gavel text-primary-600 dark:text-primary-400 mt-1"></i>
                                <div>
                                    <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-1">Formal</h3>
                                    <p className="text-sm text-gray-600 dark:text-gray-400">Structured and traditional</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-3 p-4 bg-primary-50 dark:bg-primary-900/30 rounded-lg">
                                <i className="fas fa-handshake text-primary-600 dark:text-primary-400 mt-1"></i>
                                <div>
                                    <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-1">Friendly</h3>
                                    <p className="text-sm text-gray-600 dark:text-gray-400">Warm and approachable</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-3 p-4 bg-primary-50 dark:bg-primary-900/30 rounded-lg">
                                <i className="fas fa-compress-alt text-primary-600 dark:text-primary-400 mt-1"></i>
                                <div>
                                    <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-1">Concise</h3>
                                    <p className="text-sm text-gray-600 dark:text-gray-400">Brief and to the point</p>
                                </div>
                            </div>
                        </div>
                    </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">Our Commitment</h2>
                            <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                            <li><strong>Quality:</strong> We strive for excellence in every rewrite</li>
                            <li><strong>Privacy:</strong> Your data is secure and confidential</li>
                            <li><strong>Innovation:</strong> We continuously improve our technology</li>
                            <li><strong>Accessibility:</strong> Easy-to-use tools for everyone</li>
                        </ul>
                    </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">Get in Touch</h2>
                            <p className="text-gray-700 dark:text-gray-300 mb-4">
                            We'd love to hear from you! Whether you have questions, feedback, or suggestions, please feel free 
                            to reach out to us at{' '}
                            <a href="mailto:contact@rewriteking.com" className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300">
                                contact@rewriteking.com
                            </a>
                        </p>
                    </section>
                </div>

                <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800">
                    <Link to="/" className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 font-medium">
                        ← Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;

